import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import axiosInstance from '../../config/axiosInterceptor'


const FamilyCount = () => {
  const [editable, setEditable] = useState(false);
  const [Image, setImage] = useState("");
  const [ImageW, setImageW] = useState("");
  const [newImage, setNewImage] = useState(null);
  const [newImageW, setNewImageW] = useState(null);
  const [Id, setId] = useState("");
  const [count, setcount] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth()); // Default month is June
  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [targetValue, setTargetValue] = useState(null);
  const [targetLists, setTargetLists] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [tagHistoryData, setTagHistoryData] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [activeHistoryTab, setActiveHistoryTab] = useState("history"); // "history" | "adminRewards"
  const [adminInventoryData, setAdminInventoryData] = useState([]);
  const [loadingAdminInventory, setLoadingAdminInventory] = useState(false);
  const [allTags, setAllTags] = useState([]);
  const [adminInvForm, setAdminInvForm] = useState({ tagId: "", count: "", mCoins: "", expiresAt: "" });
  const [submittingAdminInv, setSubmittingAdminInv] = useState(false);
  const [openActionId, setOpenActionId] = useState(null);
  const [actionMenuPos, setActionMenuPos] = useState({ top: 0, left: 0 });
  const actionCloseRef = useRef(null);
  const baseUrl = process.env.REACT_APP_BASEURL1;
  const baseUrl2 = process.env.REACT_APP_BASEURL2;
  const baseUrl3 = process.env.REACT_APP_BASEURL3;
  const baseUrl5 = process.env.REACT_APP_BASEURL5;

  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  // Close action dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (actionCloseRef.current && !actionCloseRef.current.contains(e.target)) {
        setOpenActionId(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleEditClick = () => {
    setEditable(true);
  };

  const handleCancelClick = () => {
    setEditable(false);
    setInputValue(""); // Reset input value on cancel
  };

  const handleSaveClick = () => {
    setEditable(false);
    // Perform save operation here with inputValue
    // For example, you can send it to an API or update state in parent component
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const getTargetPoints = async () => {
    try {
      const { data } = await axiosInstance.get(
        `${baseUrl5}/admin/familyImage/targetall?q=${+selectedMonth + 1}`
      );
      if (data.success == 1) {
        setTargetLists(data.details);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const [targetEdit, setTargetEdit] = useState("");
  const updateTargetPoints = async () => {
    try {
      if (/^\d*$/.test(targetEdit)) {
        const { data } = await axiosInstance.put(
          `${baseUrl5}/admin/familyImage/updatetarget?targetId=${targetLists[0]?._id}&targetPoints=${targetEdit}`
        );
        if (data.success == 1) {
          toast.success(data.message);
          getTargetPoints();
          setIsEdit(false);
        } else {
          toast.error(data.message);
        }
      } else {
        toast.error("Please enter a valid number");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const data1 = async () => {
    try {
      const data = await axiosInstance.get(`${baseUrl5}/admin/familyImage/image`);

      setcount(data.data.details[0].count);
      setImage(data.data.details[0].image);
      setImageW(data.data.details[0]?.weekImage);
      setId(data.data.details[0]._id);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEditable(false);

    try {
      const formData = new FormData();

      if (inputValue.trim() !== "") {
        formData.append("count", inputValue);
      } else {
        formData.append("count", count);
      }
      formData.append("image", newImage);
      formData.append("weekImage", newImageW);

      const editdata = await axiosInstance.post(
        `${baseUrl5}/admin/familyImage/update?id=${Id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(editdata);
      toast.success("Family image updated successfully");
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    data1();
  }, []);

  const [families, setFamilies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [cur, setCur] = useState(1);



  const handlePageChange = (page) => {
    fetchFamilies(page);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCur(1);
  };

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const addTotalPointsOfFamily = async (valueD) => {
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl5}/admin/familyImage/targetPoints`,
        {
          targetPoints: valueD,
        }
      );
      if (data.success == 1) {
        toast.success(data.message);
        closeModal();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error.message);
      toast.error(error.message);
    }
  };
  const getWeekNumberFromJulyIST = (date) => {
    // Define the start date (July 1, 2024, 00:00 IST)
    const startDate = new Date(Date.UTC(2024, 6, 1, -5, -30)); // July 1, 2024, at 00:00 IST
    // Calculate the difference in days from the start date
    const diffInDays = Math.floor((date - startDate) / 86400000); // 86400000 ms per day

    // Calculate the week number, adding 1 to start from Week 1
    const weekNumber = Math.floor(diffInDays / 7) + 1;

    return weekNumber;
  };
  const generateWeeks = () => {
    const today = new Date();
    // Set today to the nearest Monday
    const dayOfWeek = today.getDay();
    const diffToMonday = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek;
    const monday = new Date(today);
    monday.setDate(today.getDate() + diffToMonday);

    const weeks = [];
    for (let i = 0; i < 5; i++) {
      const startOfWeek = new Date(monday);
      startOfWeek.setDate(monday.getDate() - i * 7);

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      const weekNumber = getWeekNumberFromJulyIST(startOfWeek);

      weeks.push({
        label: `${startOfWeek.toLocaleDateString()} to ${endOfWeek.toLocaleDateString()}`,
        value: weekNumber,
      });
    }
    return weeks;
  };
  const [viewType, setViewType] = useState("month"); // Default to 'month'
  const [weeks, setWeeks] = React.useState(generateWeeks());
  const [selectedWeek, setSelectedWeek] = React.useState(weeks[0]?.value || "");

  useEffect(() => {
    if (viewType === "week") {
      generateWeeks();
    }
  }, [viewType]);



  const handleViewTypeChange = (e) => {
    setViewType(e.target.value);
  };

  const handleWeekChange = (e) => {
    const selectedIndex = e.target.value;
    setSelectedWeek(selectedIndex);
  };

  const fetchTagHistory = async (leaderId, familyId) => {
    setLoadingHistory(true);
    try {
      const monthYearParam = `${year}-${String(+selectedMonth + 1).padStart(2, "0")}`;
      const { data } = await axiosInstance.get(
        `${baseUrl5}/admin/familyImage/getLeaderTagHistory?leaderId=${leaderId}&familyId=${familyId}&monthYear=${monthYearParam}`
      );
      if (data.success === 1) {
        setTagHistoryData(data.data);
      } else {
        toast.error(data.message);
        setTagHistoryData([]);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch tag history");
      setTagHistoryData([]);
    } finally {
      setLoadingHistory(false);
    }
  };

  const fetchTagsForAdmin = async () => {
    if (allTags.length > 0) return;
    try {
      const { data } = await axiosInstance.get(`${baseUrl5}/admin/tag/getTag`);
      if (data.success === 1) setAllTags(data.tags || data.data || []);
    } catch (_) {}
  };

  const fetchAdminInventory = async (familyId) => {
    setLoadingAdminInventory(true);
    try {
      const { data } = await axiosInstance.get(
        `${baseUrl5}/admin/familyrankreward/admin-inventory/list?search=${encodeURIComponent("")}&limit=50`
      );
      if (data.success === 1) {
        // filter to this family
        const filtered = (data.data || []).filter((inv) => inv.family?._id === familyId);
        setAdminInventoryData(filtered);
      } else {
        setAdminInventoryData([]);
      }
    } catch (_) {
      setAdminInventoryData([]);
    } finally {
      setLoadingAdminInventory(false);
    }
  };

  const handleGiveAdminInventory = async (e) => {
    e.preventDefault();
    if (!selectedHistory) return;
    if (!adminInvForm.tagId) return toast.error("Please select a tag");
    if (!adminInvForm.count || parseInt(adminInvForm.count) <= 0) return toast.error("Count must be > 0");
    if (!adminInvForm.expiresAt) return toast.error("Please set an expiry date");
    setSubmittingAdminInv(true);
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl5}/admin/familyrankreward/admin-inventory/give`,
        {
          familyId: selectedHistory._id,
          tagId: adminInvForm.tagId,
          count: parseInt(adminInvForm.count),
          mCoins: parseInt(adminInvForm.mCoins) || 0,
          expiresAt: adminInvForm.expiresAt,
        }
      );
      if (data.success === 1) {
        toast.success(data.message);
        setAdminInvForm({ tagId: "", count: "", mCoins: "", expiresAt: "" });
        fetchAdminInventory(selectedHistory._id);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setSubmittingAdminInv(false);
    }
  };

  const handleDeleteAdminInventory = async (id) => {
    if (!window.confirm("Delete this admin inventory?")) return;
    try {
      const { data } = await axiosInstance.delete(
        `${baseUrl5}/admin/familyrankreward/admin-inventory/${id}`
      );
      if (data.success === 1) {
        toast.success(data.message);
        fetchAdminInventory(selectedHistory._id);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleTriggerRewards = async () => {
    if (window.confirm(`Are you sure you want to trigger rewards distribution for ${new Date(year, selectedMonth).toLocaleString('en-US', { month: 'long', year: 'numeric' })}?`)) {
      try {
        const { data } = await axiosInstance.post(
          `${baseUrl5}/admin/familyrankreward/trigger-rewards?month=${selectedMonth}&year=${year}`
        );
        if (data.success === 1) {
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || "Failed to trigger rewards");
      }
    }
  };

  const fetchFamilies = async (page = 1) => {
    try {
      setFamilies([]);
      let url = `${baseUrl5}/admin/familyImage/familyrank?page=${page}&limit=${itemsPerPage}&month=${selectedMonth}&year=${year}`;
      if (viewType === "week") url = `${baseUrl5}/admin/familyImage/familyrank?page=${page}&limit=${itemsPerPage}&month=${selectedMonth}&week=${selectedWeek}`
      const { data } = await axiosInstance.get(
        url
      );
      setFamilies(data.details);
      // setCurrentPage(data.pagination.currentPage);
      // setTotalPages(data.pagination.totalPages);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch families");
    }
  };

  useEffect(() => {
    fetchFamilies();
    getTargetPoints();
  }, [itemsPerPage, selectedMonth, selectedWeek, viewType,year]);
  return (
    <>
      <style>{`
        .fc-action-btn { background: linear-gradient(135deg,#1e3a5f,#2d6a9f); color:#fff !important; border:none; border-radius:7px; padding:5px 14px; font-size:12px; font-weight:600; cursor:pointer; display:inline-flex; align-items:center; gap:5px; white-space:nowrap; }
        .fc-action-btn:hover { background: linear-gradient(135deg,#163059,#245a8a); }
        .fc-action-menu { position:fixed; background:#fff; border-radius:10px; box-shadow:0 8px 32px rgba(0,0,0,0.18); min-width:170px; z-index:99999; overflow:hidden; border:1px solid #e8ecf0; }
        .fc-action-menu a, .fc-action-menu button { display:flex; align-items:center; gap:9px; width:100%; padding:10px 16px; font-size:13px; color:#222 !important; text-decoration:none; background:transparent; border:none; cursor:pointer; text-align:left; transition:background 0.12s; }
        .fc-action-menu a:hover, .fc-action-menu button:hover { background:#f0f7ff; color:#1565c0 !important; }
        .fc-action-menu .fc-menu-divider { height:1px; background:#f0f0f0; margin:2px 0; }
      `}</style>
      {isEdit && (
        <div
          className="modal show d-block"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex={-1}
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
          style={{ zIndex: 1050 }}
        >
          <div className="modal-dialog" style={{ marginTop: "30rem" }}>
            <div className="modal-content">
              <div className="modal-header">
                <h2 className="modal-title" id="staticBackdropLabel">
                  Update Target Points
                </h2>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>

              <form
                className="modal-body "
                onSubmit={(e) => {
                  e.preventDefault();

                  updateTargetPoints();
                }}
              >
                <>
                  <div
                    className="form-floating mt-5"
                    style={{ marginBottom: "2rem" }}
                  >
                    <label htmlFor="floatingInput">Total Points</label>
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInput"
                      placeholder="Total Points"
                      name="targetPoints"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          // Checks if the value contains only digits
                          setTargetEdit(value);
                        }
                      }}
                    />
                  </div>

                  <div>
                    <button
                      type="submit"
                      className="btn btn-success"
                      style={{ fontSize: "1.8rem" }}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setIsEdit(false);
                      }}
                      className="btn btn-danger"
                      data-bs-dismiss="modal"
                      style={{ fontSize: "1.8rem", marginLeft: "2rem" }}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              </form>
            </div>
          </div>
        </div>
      )}
      {isOpen && (
        <div
          className="modal show d-block"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex={-1}
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
          style={{ zIndex: 1050 }}
        >
          <div className="modal-dialog" style={{ marginTop: "30rem" }}>
            <div className="modal-content">
              <div className="modal-header">
                <h2 className="modal-title" id="staticBackdropLabel">
                  Add Family Target
                </h2>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>

              <form
                className="modal-body "
                onSubmit={(e) => {
                  e.preventDefault();
                  addTotalPointsOfFamily(targetValue);
                }}
              >
                <>
                  <div
                    className="form-floating mt-5"
                    style={{ marginBottom: "2rem" }}
                  >
                    <label htmlFor="floatingInput">Total Points</label>
                    <input
                      type="text"
                      className="form-control"
                      id="floatingInput"
                      placeholder="Total Points"
                      name="targetPoints"
                      onChange={(e) => {
                        setTargetValue(e.target.value);
                      }}
                    />
                  </div>

                  <div>
                    <button
                      type="submit"
                      className="btn btn-success"
                      style={{ fontSize: "1.8rem" }}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      onClick={closeModal}
                      className="btn btn-danger"
                      data-bs-dismiss="modal"
                      style={{ fontSize: "1.8rem", marginLeft: "2rem" }}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              </form>
            </div>
          </div>
        </div>
      )}

      <section className="content-header">
        <h1>Manage Family Count</h1>
        <ol className="breadcrumb">
          <li>
            <Link to="/admin">
              <i className="fa fa-dashboard"></i> Home
            </Link>
          </li>
          <li>
            <Link to="/admin/manageTag">Manage Family</Link>
          </li>
        </ol>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-md-12">
            <form
              role="form"
              method="post"
              encType="multipart/form-data"
              id="form"
            >
              <div className="box box-warning">
                <div className="box-header with-border">
                  <h3 className="box-title">Manage</h3>
                </div>
                <div className="box-body">
                  <div className="form-group">
                    <label>Family Count*</label>
                    {editable ? (
                      <>
                        <span style={{ display: "flex" }}>
                          <input
                            type="number"
                            className="form-control"
                            name="count"
                            placeholder="Count"
                            defaultValue={count}
                            value={inputValue}
                            onChange={handleChange}
                            style={{ width: "50%" }}
                          />
                          <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                            <label htmlFor="image">MonthImage</label>
                            <input
                              type="file"
                              className="form-control"
                              name="image"
                              placeholder="select Image"
                              onChange={(e) => {
                                setNewImage(e.target.files[0]);
                              }}
                              style={{ width: "60%" }}
                            />
                            <label htmlFor="image">WeekImage</label>
                            <input
                              type="file"
                              className="form-control"
                              name="weekImage"
                              placeholder="select Image"
                              onChange={(e) => {
                                setNewImageW(e.target.files[0]);
                              }}
                              style={{ width: "60%" }}
                            />
                          </div>
                          <button
                            type="button"
                            className="btn btn-danger "
                            style={{ marginLeft: "20px", marginRight: "10px" }}
                            onClick={handleCancelClick}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSubmit}
                          >
                            Save
                          </button>
                        </span>
                      </>
                    ) : (
                      <>
                        <span style={{ display: "flex" }}>
                          <input
                            type="text"
                            className="form-control"
                            name="title"
                            placeholder="Title"
                            value={count}
                            style={{ width: "60%" }}
                            readOnly
                          />

                          <button
                            type="button"
                            className="btn btn-primary"
                            style={{ marginLeft: "20px" }}
                            onClick={handleEditClick}
                          >
                            Edit
                          </button>
                        </span>
                      </>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Old Icon Month*</label>
                    <br />

                    <img src={Image} alt="" height={"80px"} />
                  </div>
                  <div className="form-group">
                    <label>Old Icon Week*</label>
                    <br />

                    <img src={ImageW} alt="" height={"80px"} />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="box box-warning fc-table-wrap">
              <div className="box-header with-border">
                <h3 className="box-title">Family Ranking</h3>
              </div>
              <div className="box-body text-dark" style={{ color: "black" }}>
                <div className="form-group">
                  <label htmlFor="itemsPerPage">Items per page:</label>
                  <select
                    id="itemsPerPage"
                    className="form-control"
                    style={{
                      width: "auto",
                      display: "inline-block",
                      marginLeft: "10px",
                    }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value={10}>10</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={500}>500</option>
                  </select>
                </div>
                <section className="content">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="box box-warning fc-table-wrap">
                        <div className="box-header with-border">
                          <h3 className="box-title">Family Ranking</h3>
                        </div>
                        <div className="box-body text-dark" style={{ color: "black" }}>
                          <div className="form-group">
                            <label htmlFor="viewType">View by:</label>
                            <select
                              id="viewType"
                              className="form-control"
                              style={{ width: "auto", display: "inline-block", marginLeft: "10px" }}
                              value={viewType}
                              onChange={handleViewTypeChange}
                            >
                              <option value="month">Month</option>
                              <option value="week">Week</option>
                            </select>
                          </div>
                          {viewType === "month" ? (
                            <div className="form-group">
                              <label htmlFor="selectMonth">Select Month:</label>
                              <select
                                id="selectMonth"
                                className="form-control"
                                style={{ width: "auto", display: "inline-block", marginLeft: "10px" }}
                                value={selectedMonth}
                                onChange={handleMonthChange}
                              >
                                <option value={0}>January</option>
                                <option value={1}>February</option>
                                <option value={2}>March</option>
                                <option value={3}>April</option>
                                <option value={4}>May</option>
                                <option value={5}>June</option>
                                <option value={6}>July</option>
                                <option value={7}>August</option>
                                <option value={8}>September</option>
                                <option value={9}>October</option>
                                <option value={10}>November</option>
                                <option value={11}>December</option>
                              </select>
                              <select style={{ padding: "8px", marginLeft: "8px" }}
                                value={year}
                                onChange={(e) => setYear(Number(e.target.value))}
                                className="form-select d-inline w-auto"
                              >
                                {Array.from(
                                  { length: 10 },
                                  (_, i) => new Date().getFullYear() - 5 + i
                                ).map((yr) => (
                                  <option key={yr} value={yr}>
                                    {yr}
                                  </option>
                                ))}
                              </select>
                              <button
                                onClick={handleTriggerRewards}
                                className="btn btn-primary"
                                style={{ marginLeft: "15px", padding: "8px 15px" }}
                                title="Trigger rewards distribution for selected month"
                              >
                                <i className="fa fa-cogs"></i> Trigger Rewards
                              </button>
                            </div>
                          ) : (
                            <div className="form-group">
                              <label htmlFor="selectWeek">Select Week:</label>
                              <select
                                id="selectWeek"
                                className="form-control"
                                style={{ width: "auto", display: "inline-block", marginLeft: "10px" }}
                                value={weeks.findIndex((w) => w === selectedWeek)}
                                onChange={handleWeekChange}
                              >
                                {weeks.map((week, index) => (
                                  <option key={index} value={week.value}>
                                    {week.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                          {/* Existing content for table and pagination */}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <div
                  className="form-group"
                  style={{ display: "flex", gap: "2rem", alignItems: "center" }}
                >
                  <button
                    onClick={openModal}
                    style={{
                      padding: ".5rem",
                      backgroundColor: "#789DBC",
                      border: "none",
                      color: "white",
                    }}
                  >
                    Add Family Target
                  </button>
                  <div
                    style={{
                      fontWeight: "bolder",
                      fontStyle: "italic",
                      display: "flex",
                      alignItems: "center",
                      gap: "2rem",
                    }}
                  >
                    Targets points:{" "}
                    {targetLists.length > 0 ? targetLists[0]?.targetPoints : 0}
                    <span
                      onClick={() => {
                        setIsEdit(true);
                      }}
                    >
                      {targetLists.length > 0 && (
                        <svg
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="15px" // Adjust the width as needed
                          height="15px"
                          viewBox="0 0 121.48 122.88"
                          xmlSpace="preserve"
                          style={{ enableBackground: "new 0 0 121.48 122.88" }}
                        >
                          <style type="text/css">
                            {`.st0{fill-rule:evenodd;clip-rule:evenodd;}`}
                          </style>
                          <g>
                            <path
                              className="st0"
                              d="M96.84,2.22l22.42,22.42c2.96,2.96,2.96,7.8,0,10.76l-12.4,12.4L73.68,14.62l12.4-12.4 
           C89.04-0.74,93.88-0.74,96.84,2.22L96.84,2.22z M70.18,52.19L70.18,52.19l0,0.01c0.92,0.92,1.38,2.14,1.38,3.34 
           c0,1.2-0.46,2.41-1.38,3.34v0.01l-0.01,0.01L40.09,88.99l0,0h-0.01c-0.26,0.26-0.55,0.48-0.84,0.67h-0.01 
           c-0.3,0.19-0.61,0.34-0.93,0.45c-1.66,0.58-3.59,0.2-4.91-1.12h-0.01l0,0v-0.01c-0.26-0.26-0.48-0.55-0.67-0.84v-0.01 
           c-0.19-0.3-0.34-0.61-0.45-0.93c-0.58-1.66-0.2-3.59,1.11-4.91v-0.01l30.09-30.09l0,0h0.01c0.92-0.92,2.14-1.38,3.34-1.38 
           c1.2,0,2.41,0.46,3.34,1.38L70.18,52.19L70.18,52.19L70.18,52.19z M45.48,109.11c-8.98,2.78-17.95,5.55-26.93,8.33 
           C-2.55,123.97-2.46,128.32,3.3,108l9.07-32v0l-0.03-0.03L67.4,20.9l33.18,33.18l-55.07,55.07L45.48,109.11L45.48,109.11z 
           M18.03,81.66l21.79,21.79c-5.9,1.82-11.8,3.64-17.69,5.45c-13.86,4.27-13.8,7.13-10.03-6.22L18.03,81.66L18.03,81.66z"
                            />
                          </g>
                        </svg>
                      )}
                    </span>
                  </div>
                </div>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Rank</th>
                      <th>Leader Username</th>
                      <th>Family Name</th>
                      <th>Points</th>
                      <th>W. Balance</th>
                      {viewType === "month" && <>
                        <th>mCoins</th>
                        <th>Admin Tags</th>
                        <th>Rank Tags</th>
                      </>}
                      <th>Action</th>
                    </tr>
                  </thead>
                  {families.length == 0 ? (
                    <>Loading...</>
                  ) : (
                    <>
                      <tbody>
                        {Array.isArray(families) &&
                          families.map((family, i) => (
                            <tr key={family._id}>
                              <td>{family.rank || (cur - 1) * itemsPerPage + i + 1}</td>
                              <td>{family.username}</td>
                              <td>{family.name}</td>
                              <td>{family.experince}</td>
                              <td>{family.balance}</td>
                              {viewType === "month" && (() => {
                                const rMCoins = family.rewards?.mCoins || 0;
                                const aMCoins = family.adminInventory?.mCoins || 0;
                                const rDetails = family.rewards?.details || [];
                                const aDetails = family.adminInventory?.details || [];
                                return (
                                  <>
                                    {/* mCoins column */}
                                    <td style={{ verticalAlign: "middle", whiteSpace: "nowrap" }}>
                                      <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                                        {/* Reward mCoins */}
                                        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                          <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#2e7d32", flexShrink: 0 }}></div>
                                          <span style={{ fontSize: 10, color: "#666", minWidth: 26 }}>Rew</span>
                                          <span style={{ fontSize: 12, fontWeight: 700, color: "#2e7d32" }}>{rMCoins}</span>
                                        </div>
                                        <div style={{ height: 1, background: "#f0f0f0" }}></div>
                                        {/* Admin mCoins */}
                                        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                          <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#c2185b", flexShrink: 0 }}></div>
                                          <span style={{ fontSize: 10, color: "#666", minWidth: 26 }}>Adm</span>
                                          <span style={{ fontSize: 12, fontWeight: 700, color: "#c2185b" }}>{aMCoins}</span>
                                        </div>
                                      </div>
                                    </td>

                                    {/* Admin Tags column */}
                                    <td style={{ verticalAlign: "middle", minWidth: 130 }}>
                                      {aDetails.length > 0 ? (
                                        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                                          {aDetails.map((d, di) => {
                                            const used = (d.originalCount ?? d.count) - d.count;
                                            const total = d.originalCount ?? d.count;
                                            const pct = total > 0 ? Math.round((d.count / total) * 100) : 0;
                                            return (
                                              <div key={di} style={{ background: "#fff8f2", border: "1px solid #ffe0b2", borderRadius: 7, padding: "5px 8px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                                                  <span style={{ fontSize: 11, fontWeight: 600, color: "#bf360c", maxWidth: 80, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{d.tagName || "Tag"}</span>
                                                  <span style={{ fontSize: 10, color: "#e65100", fontWeight: 700, background: "#fff3e0", borderRadius: 4, padding: "1px 6px", flexShrink: 0 }}>{d.count} left</span>
                                                </div>
                                                {/* Progress bar */}
                                                <div style={{ height: 4, background: "#ffe0b2", borderRadius: 4, overflow: "hidden" }}>
                                                  <div style={{ height: "100%", width: `${pct}%`, background: d.count === 0 ? "#ef9a9a" : "#ff7043", borderRadius: 4, transition: "width 0.3s" }}></div>
                                                </div>
                                                <div style={{ fontSize: 9, color: "#999", marginTop: 2 }}>{used} used / {total} given</div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      ) : <span style={{ color: "#ccc", fontSize: 12 }}>—</span>}
                                    </td>

                                    {/* Rank Tags column */}
                                    <td style={{ verticalAlign: "middle", minWidth: 130 }}>
                                      {rDetails.length > 0 ? (
                                        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                                          {rDetails.map((d, di) => {
                                            const used = (d.originalCount ?? d.count) - d.count;
                                            const total = d.originalCount ?? d.count;
                                            const pct = total > 0 ? Math.round((d.count / total) * 100) : 0;
                                            return (
                                              <div key={di} style={{ background: "#f0f7ff", border: "1px solid #bbdefb", borderRadius: 7, padding: "5px 8px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
                                                  <span style={{ fontSize: 11, fontWeight: 600, color: "#0d47a1", maxWidth: 80, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{d.tagName || "Tag"}</span>
                                                  <span style={{ fontSize: 10, color: "#1565c0", fontWeight: 700, background: "#e3f2fd", borderRadius: 4, padding: "1px 6px", flexShrink: 0 }}>{d.count} left</span>
                                                </div>
                                                {/* Progress bar */}
                                                <div style={{ height: 4, background: "#bbdefb", borderRadius: 4, overflow: "hidden" }}>
                                                  <div style={{ height: "100%", width: `${pct}%`, background: d.count === 0 ? "#90caf9" : "#1976d2", borderRadius: 4, transition: "width 0.3s" }}></div>
                                                </div>
                                                <div style={{ fontSize: 9, color: "#999", marginTop: 2 }}>{used} used / {total} given</div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      ) : <span style={{ color: "#ccc", fontSize: 12 }}>—</span>}
                                    </td>
                                  </>
                                );
                              })()}
                              <td style={{ whiteSpace: "nowrap" }}>
                                <div ref={openActionId === family._id ? actionCloseRef : null} style={{ position: "relative", display: "inline-block" }}>
                                  <button
                                    className="fc-action-btn"
                                    onClick={(e) => {
                                      if (openActionId === family._id) { setOpenActionId(null); return; }
                                      const rect = e.currentTarget.getBoundingClientRect();
                                      setActionMenuPos({ top: rect.bottom + 4, left: rect.left });
                                      setOpenActionId(family._id);
                                    }}
                                  >
                                    Actions <i className="fa fa-chevron-down" style={{ fontSize: 9 }}></i>
                                  </button>
                                  {openActionId === family._id && (
                                    <div
                                      className="fc-action-menu"
                                      style={{ top: actionMenuPos.top, left: actionMenuPos.left }}
                                    >
                                      <Link
                                        to={`/admin/ViewTransactions?id=${family._id}`}
                                        onClick={() => setOpenActionId(null)}
                                      >
                                        <i className="fa fa-eye" style={{ color: "#2d6a9f" }}></i> View Transactions
                                      </Link>
                                      {viewType === "month" && (
                                        <>
                                          <div className="fc-menu-divider"></div>
                                          <button
                                            onClick={() => {
                                              setOpenActionId(null);
                                              setSelectedHistory(family);
                                              setActiveHistoryTab("history");
                                              setAdminInvForm({ tagId: "", count: "", mCoins: "", expiresAt: "" });
                                              setShowHistoryModal(true);
                                              fetchTagHistory(family.leaderId, family._id);
                                              fetchAdminInventory(family._id);
                                              fetchTagsForAdmin();
                                            }}
                                          >
                                            <i className="fa fa-history" style={{ color: "#7c3aed" }}></i> Tag History
                                          </button>
                                          <div className="fc-menu-divider"></div>
                                          <button
                                            onClick={() => {
                                              setOpenActionId(null);
                                              setSelectedHistory(family);
                                              setActiveHistoryTab("adminRewards");
                                              setAdminInvForm({ tagId: "", count: "", mCoins: "", expiresAt: "" });
                                              setShowHistoryModal(true);
                                              fetchAdminInventory(family._id);
                                              fetchTagsForAdmin();
                                            }}
                                          >
                                            <i className="fa fa-gift" style={{ color: "#e65100" }}></i> Give Admin Reward
                                          </button>
                                        </>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </>
                  )}
                </table>
                <div className="pagination">
                  <button
                    className="btn btn-default"
                    disabled={currentPage === 1}
                    onClick={() => {
                      setCur(cur - 1);
                      handlePageChange(cur - 1);
                    }}
                  >
                    Prev
                  </button>
                  <button
                    className="btn btn-default"
                    disabled={currentPage === totalPages}
                    onClick={() => {
                      setCur(cur + 1);
                      handlePageChange(cur + 1);
                    }}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── History / Admin Rewards Modal ── */}
      {showHistoryModal && selectedHistory && (
        <div
          style={{
            position: "fixed", inset: 0, zIndex: 9999,
            background: "rgba(15,23,42,0.55)",
            display: "flex", alignItems: "flex-start", justifyContent: "center",
            padding: "40px 16px 24px",
            overflowY: "auto",
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setShowHistoryModal(false);
              setSelectedHistory(null);
              setTagHistoryData([]);
              setAdminInventoryData([]);
            }
          }}
        >
          <div
            style={{
              background: "#fff", borderRadius: 14, width: "100%", maxWidth: 860,
              boxShadow: "0 20px 60px rgba(0,0,0,0.22)",
              display: "flex", flexDirection: "column", overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div style={{
              background: "linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)",
              padding: "18px 24px",
              display: "flex", alignItems: "center", justifyContent: "space-between",
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{
                  width: 42, height: 42, borderRadius: "50%",
                  background: "rgba(255,255,255,0.15)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <i className="fa fa-users" style={{ color: "#fff", fontSize: 18 }}></i>
                </div>
                <div>
                  <div style={{ color: "#fff", fontWeight: 700, fontSize: 16, lineHeight: 1.2 }}>{selectedHistory.name}</div>
                  <div style={{ color: "rgba(255,255,255,0.65)", fontSize: 12 }}>@{selectedHistory.username}</div>
                </div>
              </div>
              <button
                onClick={() => { setShowHistoryModal(false); setSelectedHistory(null); setTagHistoryData([]); setAdminInventoryData([]); }}
                style={{ background: "rgba(255,255,255,0.15)", border: "none", borderRadius: 8, width: 32, height: 32, color: "#fff", fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", lineHeight: 1 }}
              >×</button>
            </div>

            {/* Tab bar */}
            <div style={{ display: "flex", borderBottom: "2px solid #f0f0f0", background: "#fafbfc" }}>
              {[
                { key: "history", icon: "fa-history", label: "Tag History" },
                { key: "adminRewards", icon: "fa-gift", label: "Rewards by Admin" },
              ].map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveHistoryTab(tab.key)}
                  style={{
                    flex: 1, padding: "12px 16px", border: "none", background: "transparent",
                    cursor: "pointer", fontSize: 13, fontWeight: activeHistoryTab === tab.key ? 700 : 500,
                    color: activeHistoryTab === tab.key ? "#2d6a9f" : "#666",
                    borderBottom: activeHistoryTab === tab.key ? "2px solid #2d6a9f" : "2px solid transparent",
                    marginBottom: -2, transition: "all 0.15s",
                    display: "flex", alignItems: "center", justifyContent: "center", gap: 7,
                  }}
                >
                  <i className={`fa ${tab.icon}`}></i> {tab.label}
                </button>
              ))}
            </div>

            {/* Body */}
            <div style={{ padding: "20px 24px", overflowY: "auto", maxHeight: "60vh" }}>

              {/* ── Tag History tab ── */}
              {activeHistoryTab === "history" && (
                loadingHistory ? (
                  <div style={{ textAlign: "center", padding: 40, color: "#888" }}>
                    <i className="fa fa-spinner fa-spin" style={{ fontSize: 28 }}></i>
                    <p style={{ marginTop: 10 }}>Loading tag history…</p>
                  </div>
                ) : tagHistoryData.length === 0 ? (
                  <div style={{ textAlign: "center", padding: 40, color: "#aaa" }}>
                    <i className="fa fa-inbox" style={{ fontSize: 36 }}></i>
                    <p style={{ marginTop: 10 }}>No tag distribution history found</p>
                  </div>
                ) : (
                  <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                      <thead>
                        <tr style={{ background: "#f4f7fb" }}>
                          {["Member", "Tag", "Month", "Status", "Given At", "Withdrawn At"].map((h) => (
                            <th key={h} style={{ padding: "10px 12px", textAlign: "left", fontWeight: 600, color: "#444", borderBottom: "2px solid #e8ecf0", whiteSpace: "nowrap" }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {tagHistoryData.map((h, i) => (
                          <tr key={h._id} style={{ background: i % 2 === 0 ? "#fff" : "#fafbfc" }}>
                            <td style={{ padding: "10px 12px", borderBottom: "1px solid #f0f0f0" }}>
                              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                {h.memberPicture ? (
                                  <img src={h.memberPicture} alt="" width={32} height={32} style={{ borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
                                ) : (
                                  <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#e0e7ef", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                    <i className="fa fa-user" style={{ color: "#90a4ae", fontSize: 14 }}></i>
                                  </div>
                                )}
                                <div>
                                  <div style={{ fontWeight: 600, color: "#222" }}>{h.memberName}</div>
                                  <div style={{ fontSize: 11, color: "#888" }}>@{h.memberUsername}</div>
                                </div>
                              </div>
                            </td>
                            <td style={{ padding: "10px 12px", borderBottom: "1px solid #f0f0f0" }}>
                              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                {h.tagImage && <img src={h.tagImage} alt="" height={28} style={{ borderRadius: 4 }} />}
                                <span style={{ fontWeight: 500 }}>{h.tagName}</span>
                              </div>
                            </td>
                            <td style={{ padding: "10px 12px", borderBottom: "1px solid #f0f0f0", color: "#555", whiteSpace: "nowrap" }}>{h.monthYear}</td>
                            <td style={{ padding: "10px 12px", borderBottom: "1px solid #f0f0f0" }}>
                              <span style={{
                                display: "inline-block", padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700,
                                background: h.withdrawn ? "#fdecea" : "#e8f5e9",
                                color: h.withdrawn ? "#c62828" : "#2e7d32",
                              }}>
                                {h.withdrawn ? "Withdrawn" : "Active"}
                              </span>
                            </td>
                            <td style={{ padding: "10px 12px", borderBottom: "1px solid #f0f0f0", color: "#555", fontSize: 12, whiteSpace: "nowrap" }}>
                              {h.givenAt ? new Date(h.givenAt).toLocaleString("en-US", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—"}
                            </td>
                            <td style={{ padding: "10px 12px", borderBottom: "1px solid #f0f0f0", color: "#555", fontSize: 12, whiteSpace: "nowrap" }}>
                              {h.withdrawnAt ? new Date(h.withdrawnAt).toLocaleString("en-US", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )
              )}

              {/* ── Rewards by Admin tab ── */}
              {activeHistoryTab === "adminRewards" && (
                <>
                  {/* Give form card */}
                  <div style={{
                    background: "linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 100%)",
                    border: "1px solid #c8def5", borderRadius: 10, padding: "16px 20px", marginBottom: 20,
                  }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
                      <div style={{ width: 28, height: 28, borderRadius: 6, background: "#2d6a9f", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <i className="fa fa-plus" style={{ color: "#fff", fontSize: 12 }}></i>
                      </div>
                      <span style={{ fontWeight: 700, fontSize: 14, color: "#1e3a5f" }}>Give Admin Inventory</span>
                    </div>
                    <form onSubmit={handleGiveAdminInventory}>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px 16px" }}>
                        <div>
                          <label style={{ fontSize: 11, fontWeight: 600, color: "#555", textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 4 }}>Tag *</label>
                          <select
                            className="form-control"
                            style={{ fontSize: 13, borderRadius: 7 }}
                            value={adminInvForm.tagId}
                            onChange={(e) => setAdminInvForm((f) => ({ ...f, tagId: e.target.value }))}
                            required
                          >
                            <option value="">— Select Tag —</option>
                            {allTags.map((t) => <option key={t._id} value={t._id}>{t.title}</option>)}
                          </select>
                        </div>
                        <div>
                          <label style={{ fontSize: 11, fontWeight: 600, color: "#555", textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 4 }}>Count *</label>
                          <input
                            type="number" min="1"
                            className="form-control"
                            style={{ fontSize: 13, borderRadius: 7 }}
                            placeholder="e.g. 5"
                            value={adminInvForm.count}
                            onChange={(e) => setAdminInvForm((f) => ({ ...f, count: e.target.value }))}
                            required
                          />
                        </div>
                        <div>
                          <label style={{ fontSize: 11, fontWeight: 600, color: "#555", textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 4 }}>mCoins <span style={{ color: "#999", fontWeight: 400, textTransform: "none" }}>(credited now)</span></label>
                          <input
                            type="number" min="0"
                            className="form-control"
                            style={{ fontSize: 13, borderRadius: 7 }}
                            placeholder="e.g. 100"
                            value={adminInvForm.mCoins}
                            onChange={(e) => setAdminInvForm((f) => ({ ...f, mCoins: e.target.value }))}
                          />
                        </div>
                        <div>
                          <label style={{ fontSize: 11, fontWeight: 600, color: "#555", textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 4 }}>Expires At *</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            style={{ fontSize: 13, borderRadius: 7 }}
                            value={adminInvForm.expiresAt}
                            onChange={(e) => setAdminInvForm((f) => ({ ...f, expiresAt: e.target.value }))}
                            required
                          />
                        </div>
                      </div>
                      <div style={{ marginTop: 14, display: "flex", justifyContent: "flex-end" }}>
                        <button
                          type="submit"
                          disabled={submittingAdminInv}
                          style={{
                            background: submittingAdminInv ? "#90a4ae" : "linear-gradient(135deg, #1e3a5f, #2d6a9f)",
                            color: "#fff", border: "none", borderRadius: 8,
                            padding: "9px 24px", fontWeight: 600, fontSize: 13, cursor: submittingAdminInv ? "not-allowed" : "pointer",
                            display: "flex", alignItems: "center", gap: 7,
                          }}
                        >
                          {submittingAdminInv
                            ? <><i className="fa fa-spinner fa-spin"></i> Giving…</>
                            : <><i className="fa fa-paper-plane"></i> Give Inventory</>
                          }
                        </button>
                      </div>
                    </form>
                  </div>

                  {/* Inventory list */}
                  {loadingAdminInventory ? (
                    <div style={{ textAlign: "center", padding: 40, color: "#888" }}>
                      <i className="fa fa-spinner fa-spin" style={{ fontSize: 28 }}></i>
                      <p style={{ marginTop: 10 }}>Loading…</p>
                    </div>
                  ) : adminInventoryData.length === 0 ? (
                    <div style={{ textAlign: "center", padding: 30, color: "#aaa", background: "#fafbfc", borderRadius: 10, border: "1px dashed #ddd" }}>
                      <i className="fa fa-inbox" style={{ fontSize: 32 }}></i>
                      <p style={{ marginTop: 8, fontSize: 13 }}>No admin inventory given yet</p>
                    </div>
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                      {adminInventoryData.map((inv) => (
                        <div
                          key={inv._id}
                          style={{
                            display: "flex", alignItems: "center", gap: 14,
                            background: inv.expired ? "#fff8f8" : "#fff",
                            border: `1px solid ${inv.expired ? "#ffd0cc" : "#e8ecf0"}`,
                            borderRadius: 10, padding: "12px 16px",
                            boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                          }}
                        >
                          <div style={{ width: 44, height: 44, borderRadius: 8, background: "#f0f4f8", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, overflow: "hidden" }}>
                            {inv.tag?.image
                              ? <img src={inv.tag.image} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} onError={(e) => (e.target.style.display = "none")} />
                              : <i className="fa fa-tag" style={{ color: "#90a4ae", fontSize: 20 }}></i>
                            }
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontWeight: 700, color: "#222", fontSize: 14 }}>{inv.tag?.title || "—"}</div>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 5 }}>
                              <span style={{ fontSize: 11, color: "#555" }}>
                                <b style={{ color: "#1565c0" }}>{inv.count}</b> remaining
                                {inv.originalCount != null && inv.originalCount !== inv.count && (
                                  <span style={{ color: "#999", marginLeft: 4 }}>/ {inv.originalCount} given</span>
                                )}
                              </span>
                              {inv.mCoinsEarned > 0 && <span style={{ fontSize: 11, color: "#555" }}><b style={{ color: "#2e7d32" }}>{inv.mCoinsEarned}</b> mCoins</span>}
                              <span style={{ fontSize: 11, color: "#555" }}>Expires: <b>{inv.expiresAt ? new Date(inv.expiresAt).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—"}</b></span>
                            </div>
                          </div>
                          <span style={{
                            flexShrink: 0, padding: "4px 12px", borderRadius: 20, fontSize: 11, fontWeight: 700,
                            background: inv.expired ? "#fdecea" : "#e8f5e9",
                            color: inv.expired ? "#c62828" : "#2e7d32",
                          }}>
                            {inv.expired ? "Expired" : "Active"}
                          </span>
                          <button
                            onClick={() => handleDeleteAdminInventory(inv._id)}
                            style={{ flexShrink: 0, background: "#fdecea", border: "none", borderRadius: 8, width: 32, height: 32, color: "#c62828", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                            title="Delete"
                          >
                            <i className="fa fa-trash" style={{ fontSize: 13 }}></i>
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>

            {/* Footer */}
            <div style={{ padding: "14px 24px", borderTop: "1px solid #f0f0f0", display: "flex", justifyContent: "flex-end", background: "#fafbfc" }}>
              <button
                onClick={() => { setShowHistoryModal(false); setSelectedHistory(null); setTagHistoryData([]); setAdminInventoryData([]); }}
                style={{ background: "#f0f0f0", border: "none", borderRadius: 8, padding: "8px 22px", fontWeight: 600, fontSize: 13, color: "#444", cursor: "pointer" }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FamilyCount;
